import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { trackCxFoundationsContactFormCloseClick } from "@faire/web-api--source/events/cxFoundations/click/contactFormClose";
import { trackCxFoundationsHowCanIHelpToHelpCenterNextClick } from "@faire/web-api--source/events/cxFoundations/click/howCanIHelpToHelpCenterNext";
import { trackCxFoundationsINeedMoreHelpClick } from "@faire/web-api--source/events/cxFoundations/click/iNeedMoreHelp";
import get from "lodash/get";
import omit from "lodash/omit";
import qs from "query-string";
import { useHistory, useLocation } from "react-router-dom";
import { EVENT, STEP } from "../consts";
import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";
import { useLoggedOutIssuesDropdown } from "./useLoggedOutIssuesDropdown";
import { useLoggedOutIssueType } from "./useLoggedOutIssueType";
export var useLoggedOutContactUsNavigation = function useLoggedOutContactUsNavigation() {
  var location = useLocation();
  var history = useHistory();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    feedbackCollectedByIssueType = _useState2[0],
    setFeedbackCollectedByIssueType = _useState2[1];
  var _useLoggedOutContactU = useLoggedOutContactUsContextStore(["currentStep"]),
    _useLoggedOutContactU2 = _slicedToArray(_useLoggedOutContactU, 2),
    currentStep = _useLoggedOutContactU2[0].currentStep,
    setLoggedOutContactUsContextStore = _useLoggedOutContactU2[1];
  var _useLoggedOutIssuesDr = useLoggedOutIssuesDropdown(),
    issueL1 = _useLoggedOutIssuesDr.issueL1,
    issueL2 = _useLoggedOutIssuesDr.issueL2,
    issueL3 = _useLoggedOutIssuesDr.issueL3,
    showDropdownL2 = _useLoggedOutIssuesDr.showDropdownL2,
    showDropdownL3 = _useLoggedOutIssuesDr.showDropdownL3;
  var _useLoggedOutIssueTyp = useLoggedOutIssueType(),
    issueType = _useLoggedOutIssueTyp.issueType;
  var eventPage = EVENT.HOW_CAN_WE_HELP_PAGE;
  var nextBtnDisabled = function nextBtnDisabled() {
    if (!issueL1) {
      return true;
    }
    if (showDropdownL2() && !issueL2) {
      return true;
    }
    if (showDropdownL3() && !issueL3) {
      return true;
    }
    return false;
  };
  var isFirstStep = currentStep === STEP.LOGGED_OUT_SELECT_TOPIC;
  var isLastStep = currentStep === STEP.CONFIRMATION;
  var goToNextStep = function goToNextStep() {
    var _getRetailerToken, _getBrandToken, _getRetailerToken2, _getBrandToken2;
    switch (currentStep) {
      case STEP.LOGGED_OUT_SELECT_TOPIC:
        setLoggedOutContactUsContextStore({
          currentStep: STEP.HELP_CENTER_ARTICLE
        });
        eventPage = EVENT.DOES_THIS_HELP_PAGE;
        trackCxFoundationsHowCanIHelpToHelpCenterNextClick(issueType, (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "", (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "");
        break;
      case STEP.HELP_CENTER_ARTICLE:
        setLoggedOutContactUsContextStore({
          currentStep: STEP.LOGGED_OUT_CONTACT_US
        });
        eventPage = EVENT.CONTACT_US_PAGE;
        trackCxFoundationsINeedMoreHelpClick(issueType, (_getRetailerToken2 = getRetailerToken()) !== null && _getRetailerToken2 !== void 0 ? _getRetailerToken2 : "", (_getBrandToken2 = getBrandToken()) !== null && _getBrandToken2 !== void 0 ? _getBrandToken2 : "");
        break;
      case STEP.LOGGED_OUT_CONTACT_US:
        setLoggedOutContactUsContextStore({
          currentStep: STEP.CONFIRMATION
        });
        eventPage = EVENT.CONFIRMATION_PAGE;
        break;
      default:
        setLoggedOutContactUsContextStore({
          currentStep: STEP.LOGGED_OUT_SELECT_TOPIC
        });
        eventPage = EVENT.HOW_CAN_WE_HELP_PAGE;
        break;
    }
  };
  var goToPrevStep = function goToPrevStep() {
    switch (currentStep) {
      case STEP.LOGGED_OUT_SELECT_TOPIC:
        setLoggedOutContactUsContextStore({
          currentStep: STEP.LOGGED_OUT_SELECT_TOPIC
        });
        eventPage = EVENT.HOW_CAN_WE_HELP_PAGE;
        break;
      case STEP.HELP_CENTER_ARTICLE:
        setLoggedOutContactUsContextStore({
          currentStep: STEP.LOGGED_OUT_SELECT_TOPIC
        });
        eventPage = EVENT.HOW_CAN_WE_HELP_PAGE;
        break;
      case STEP.LOGGED_OUT_CONTACT_US:
        if (nextBtnDisabled()) {
          setLoggedOutContactUsContextStore({
            currentStep: STEP.LOGGED_OUT_SELECT_TOPIC
          });
          eventPage = EVENT.HOW_CAN_WE_HELP_PAGE;
        } else {
          setLoggedOutContactUsContextStore({
            currentStep: STEP.HELP_CENTER_ARTICLE
          });
          eventPage = EVENT.DOES_THIS_HELP_PAGE;
        }
        break;
      default:
        setLoggedOutContactUsContextStore({
          currentStep: STEP.LOGGED_OUT_SELECT_TOPIC
        });
        eventPage = EVENT.HOW_CAN_WE_HELP_PAGE;
        break;
    }
  };
  var removeContactQueryParam = function removeContactQueryParam() {
    var parse = qs.parse,
      stringify = qs.stringify;
    var pathname = get(location, "pathname");
    var query = parse(get(location, "search", ""));
    var omitParams = stringify(omit(query, ["contact", "loggedOut"]));
    var queryParams = omitParams ? "?".concat(omitParams) : omitParams;
    history.push("".concat(pathname).concat(queryParams));
  };
  var setFeedbackCollected = function setFeedbackCollected(key, value) {
    setFeedbackCollectedByIssueType(_objectSpread(_objectSpread({}, feedbackCollectedByIssueType), {}, _defineProperty({}, key, value)));
  };
  var closeModal = function closeModal() {
    removeContactQueryParam();
    setFeedbackCollectedByIssueType({});
    trackCxFoundationsContactFormCloseClick(issueType, "", eventPage);
  };
  return {
    nextBtnDisabled: nextBtnDisabled,
    setFeedbackCollected: setFeedbackCollected,
    feedbackCollectedByIssueType: feedbackCollectedByIssueType,
    closeModal: closeModal,
    goToNextStep: goToNextStep,
    goToPrevStep: goToPrevStep,
    currentStep: currentStep,
    isLastStep: isLastStep,
    isFirstStep: isFirstStep
  };
};